export default __webpack_public_path__ + "static/media/subtract-mobile.9611e09d.svg";